var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { styled } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import MUICheckbox from "@mui/material/Checkbox";
import { convertPxToRem } from "../../util-functions";
import { Icon } from "../Icon";
const StyledIcon = styled("div", {
    shouldForwardProp: (prop) => prop !== "error",
})(({ theme, error }) => ({
    borderRadius: convertPxToRem(6),
    border: `1.5px solid ${error ? theme.palette.error.main : theme.palette.grey05.main}`,
    transition: "all 0.2s",
    width: convertPxToRem(17),
    height: convertPxToRem(17),
    "input:hover ~ &": {
        borderColor: theme.palette.grey07.main,
    },
    "input:disabled ~ &": {
        borderColor: theme.palette.grey04.main,
        background: theme.palette.grey03.main,
        transition: "none",
    },
    ".Mui-focusVisible &": {
        borderColor: theme.palette.primaryBlack.main,
    },
}));
const StyledCheckedIconWrapper = styled(StyledIcon)(({ theme }) => ({
    borderColor: theme.palette.sativaGreen.main,
    background: theme.palette.sativaGreen.main,
    "span ": {
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "end",
        fontSize: convertPxToRem(15),
    },
    "input:hover ~ &": {
        background: theme.palette.green06.main,
        borderColor: theme.palette.green06.main,
    },
}));
const StyledDashedIconWrapper = styled(StyledIcon)(({ theme }) => ({
    borderColor: theme.palette.sativaGreen.main,
    background: theme.palette.sativaGreen.main,
    "span ": {
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "end",
        fontSize: convertPxToRem(15),
    },
    "input:hover ~ &": {
        background: theme.palette.green06.main,
        borderColor: theme.palette.green06.main,
    },
}));
const CustomIconCheckbox = (props) => {
    const { error } = props, rest = __rest(props, ["error"]);
    return (_jsx(MUICheckbox, Object.assign({ disableRipple: true, checkedIcon: _jsx(StyledCheckedIconWrapper, Object.assign({ error: error }, { children: _jsx(Icon, { iconName: "Checkmark", fontSize: "small", color: rest.disabled ? "disabledText" : "primaryBlackText" }) })), icon: _jsx(StyledIcon, { error: error }), indeterminateIcon: _jsx(StyledDashedIconWrapper, Object.assign({ error: error }, { children: _jsx(Icon, { iconName: "Remove", fontSize: "small", color: rest.disabled ? "disabledText" : "primaryBlackText" }) })) }, rest)));
};
const StyledCheckbox = styled(CustomIconCheckbox)(() => ({
    padding: "0",
    borderRadius: convertPxToRem(6),
}));
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: "0",
    ".MuiFormControlLabel-label": Object.assign(Object.assign({}, theme.typography.largeText), { transition: "all 0.2s", paddingLeft: convertPxToRem(10) }),
    ".Mui-disabled": {
        color: theme.palette.disabledText.main,
        transition: "none",
    },
}));
export const Checkbox = ({ checked, disabled = false, error = false, hideLabel = false, label, onChange, required = false, testId, useDashIcon = false, value, }) => {
    const [isChecked, setIsChecked] = useState(false);
    const checkboxOnChange = (event) => {
        const target = event.target;
        setIsChecked(target.checked);
        if (onChange) {
            onChange(target.checked);
        }
    };
    if (!hideLabel) {
        return (_jsx(FormControl, Object.assign({ required: required, error: error }, { children: _jsx(StyledFormControlLabel, { control: _jsx(StyledCheckbox, { error: error, indeterminate: useDashIcon, inputProps: { "aria-label": label } }), "data-testid": testId, label: label, disabled: disabled, 
                // If no checked prop is passed to the component, Checkbox handles its checked/unchecked state internally
                checked: checked !== null && checked !== void 0 ? checked : isChecked, value: value, onChange: checkboxOnChange }) })));
    }
    return (_jsx(FormControl, Object.assign({ required: required, error: error }, { children: _jsx(StyledCheckbox, { "data-testid": testId, onChange: checkboxOnChange, value: value, indeterminate: useDashIcon, inputProps: { "aria-label": label }, disabled: disabled, 
            // If no checked prop is passed to the component, Checkbox handles its checked/unchecked state internally
            checked: checked !== null && checked !== void 0 ? checked : isChecked, error: error }) })));
};
